module.exports = __webpack_public_path__ + "res/ic_end_campaign.a905000b5f8236485ec7ef865343b881.png";